export default "__VITE_ASSET__B2Yk16gd__"